import React, { useState, useEffect, useCallback } from 'react'
import * as Yup from 'yup'
import moment from 'moment'
import { Formik, Form, Field } from 'formik'
import { useSelector, useDispatch } from 'react-redux'
import { useModal } from 'react-modal-hook'
import Modal from '../../components/Modal/Modal'
import PaymentsService from '../../services/payments.service'
import InputError from '../../components/InputError/InputError'
import NeoButton from '../../components/NeoButton/NeoButton'
import NeoInput from '../../components/NeoInput/NeoInput'
import NeoOTP from '../../components/FormComponents/NeoOTP'
import NeoSuccess from '../../components/FormComponents/NeoSuccess'
import { useHistory, useLocation } from 'react-router-dom'
import DashboardService from '../../services/dashboard.service'
import { setAccRefresh, setBillersList, setRemarks } from '../../actions'
import NumberFormat from 'react-number-format'
import LayoutWithAccountCard from '../../layout/Layout/layout-account-card'
import NeoLoader from '../../components/FormComponents/NeoLoader'
import AccountDisplay from '../../components/account-display/account-display'
import TermsAndConditions from '../../components/TermsAndConditions/TermsAndCondition'
import {
  getFeatureListSelector,
  remarksSelector,
  carouselCurrentItemSelector,
} from '../../selectors'
import { useTranslation } from 'react-i18next'
import {
  DIALOG_KEYS,
  VALIDATION_MESSAGES,
  DEPOSITS_KEYS,
  SIDENAV_KEYS,
  PAYMENT_KEYS,
} from '../../utils/translation-constants'
import Loading from 'custom/assets/loaders/Loading'
// import clientAdditionalFields from 'custom/config/payments.additionalFields.json'
import config from 'custom/config/environment'
import 'react-datepicker/dist/react-datepicker.css'
import DatePicker from 'react-datepicker'
import { getMonth, getYear } from 'date-fns'
import range from 'lodash/range'
import BeneficiaryTransferService from '../../services/beneficiary-transfers.service'

const todayDate = new Date().toISOString().split('T')[0]

export default function SchoolPayBillerProduct() {
  const location = useLocation()
  const history = useHistory()
  const dispatch = useDispatch()
  const featureList = useSelector(getFeatureListSelector)
  const { t } = useTranslation()
  const [selectedBiller, setSelectedBiller] = useState({})
  const [selectedProduct, setSelectedProduct] = useState({})
  const [quoteDetails, setQuoteDetails] = useState({})
  const [productDetails, setProductDetails] = useState({ products: [] })
  const [otp, setOTP] = useState('')
  const [stage, setStage] = useState(0)
  const [loading, setLoading] = useState(false)
  const [loading1, setLoading1] = useState(false)
  const [formValues, setFormValues] = useState(null)
  const srcAccountDetails = useSelector(carouselCurrentItemSelector)
  const [message, setMessage] = useState('Error Placeholder')
  const [otpEnabled, setOtpEnabled] = useState(false)
  const [error, setError] = useState({})
  const [billsList, setBillsList] = useState([])
  const [billerBeneList, setBillerBeneList] = useState([])
  // const [additionalFieldValues, setAdditionalFieldValues] = useState({})
  // const [additionalFieldValidations, setAdditionalFieldValidations] = useState({})
  const [startDate, setStartDate] = useState(new Date())
  const years = range(1990, getYear(new Date()) + 1, 1)
  const [banks, setBanks] = useState([])
  const [successResponse, setSuccessResponse] = useState({})

  const LABELS = {
    CASHIN: t(PAYMENT_KEYS.MOBILE_NO),
    DATA: t(PAYMENT_KEYS.MOBILE_NO),
    CASHOUT: t(PAYMENT_KEYS.MOBILE_NO),
    TOPUP: t(PAYMENT_KEYS.MOBILE_NO),
    SCHOOLPAY: t(PAYMENT_KEYS.STUDENT_NO),
    DTH: t(PAYMENT_KEYS.SUBSCRIBER_NO),
    WATER: t(PAYMENT_KEYS.SERVICE_NO),
    ELECTRICITY: t(PAYMENT_KEYS.BILL_NUMBER),
    INTERNET: t(PAYMENT_KEYS.ACCOUNT_NO),
    INSURANCE: t(PAYMENT_KEYS.INSURANCE_NO),
    TRAVEL: t(PAYMENT_KEYS.MOBILE_NO),
    TAX: t(PAYMENT_KEYS.SERVICE_NO),
    SUBSCRIPTION: t(PAYMENT_KEYS.CUSTOMER_NO),
  }

  const [showModal, hideModal] = useModal(
    () => (
      <Modal>
        <div className='modal-error-body'>
          <h6>{error?.message}</h6>
          <div className='modal-btn-style'>
            <NeoButton
              mode='newDesign'
              type='button'
              text={t(DIALOG_KEYS.CLOSE)}
              onClick={() => {
                hideModal()
              }}
            />
          </div>
        </div>
      </Modal>
    ),
    [error],
  )

  useEffect(() => {
    if (location.state === undefined) {
      history.push('/payments/payBills')
      return
    }
    setSelectedBiller(location?.state?.serviceDetails)
    getProductDetails()
    fetchBillerBeneficiaries()
    fetchBanks()
  }, [])

  const fetchBanks = useCallback(async () => {
    const response = await PaymentsService.getAllBanks()
    const bankList = [...new Set(response.map((v) => v.bankName))]
    setBanks(bankList)
  }, [])

  const getProductDetails = useCallback(async () => {
    try {
      const { serviceDetails } = location?.state
      setLoading(true)
      const response = await PaymentsService.getServiceById({
        fetchProducts: true,
        serviceId: serviceDetails.serviceId,
      })
      if (response.status === 200) {
        setProductDetails(response.data)

        setLoading(false)
        response.data['fetchPendingBills'] ? setStage(5) : setStage(1)
        // getAdditionalFields(response.data)
      }
    } catch (err) {
      setMessage(err)
    }
  }, [])

  const fetchPendingBills = useCallback(
    async (values, setTouched) => {
      try {
        if (values.serviceNumber === '') {
          setTouched({ serviceNumber: true })
          return false
        }
        setLoading1(true)
        const { serviceDetails } = location?.state
        const response = await PaymentsService.getPendingBills({
          serviceNumber: values.serviceNumber,
          serviceId: serviceDetails.serviceId,
          srcAccount: srcAccountDetails.accountNo,
          srcAccBranch: srcAccountDetails.brnCode,
          merchant: productDetails?.merchantId || productDetails?.description,
        })
        if (response.status === 200) {
          setLoading1(false)
          if (response.data['pendingBills']) {
            setBillsList(response.data['pendingBills'])
          }
        }
      } catch (err) {
        setMessage(err)
        setLoading1(false)
      }
    },
    [productDetails],
  )

  const fetchBillerBeneficiaries = useCallback(async () => {
    try {
      const response = await PaymentsService.getAllBillerBeneficiaries()
      if (response.status === 200) {
        setBillerBeneList(
          response.data['billerBeneficiary'].filter(
            (ele) => ele.serviceId === location?.state?.serviceDetails?.serviceId,
          ),
        )
      }
    } catch (err) {}
  }, [])

  const setSelectedProductCallback = useCallback(
    (data) => {
      const selectedProductFull = productDetails.products.find(
        (value) => value.description === data,
      )
      setSelectedProduct(selectedProductFull)
    },
    [productDetails],
  )

  const handleSelectedBillCallback = useCallback(
    (data) => {
      const selectedProductFull = billsList.find((value) => value.billNumber === data)
      setSelectedProduct(selectedProductFull)
      setBillerBeneList([])
    },
    [billsList],
  )

  const submitPayment = useCallback(
    async (data, { setSubmitting }) => {
      const featureDetails = featureList['BILL_PAY']
      if (featureDetails[srcAccountDetails['accountType']] === 'N') {
        setMessage({
          code: t(DIALOG_KEYS.NO_ACCESS),
          message: t(DIALOG_KEYS.NO_ACCOUNTS),
        })
        showModal()
        return
      }

      if (data?.floatAmount === 0) {
        return
      }
      setLoading(true)
      setSubmitting(true)
      setFormValues(data)
      try {
        const response = await PaymentsService.getBillQuote({
          amount: data.debitAmount,
          srcAccBranch: srcAccountDetails.brnCode,
          merchant: productDetails?.merchantId || productDetails?.description,
          productId: selectedProduct?.productId || '',
          serviceId: productDetails.serviceId,
          serviceNumber: data.serviceNumber,
          srcAccount: srcAccountDetails.accountNo,
          isFixed: selectedProduct?.amountType == 'FIXED' ? true : false,
          voucherType: selectedProduct?.name || '',
          customerName: '',
          isScheduled: data.isScheduled === 'Yes' ? 'Y' : 'N',
          scheduledDate: data.scheduledDate,
        })
        if (response.status === 200) {
          setOtpEnabled(response.data['otpEnable'])
          setQuoteDetails(response.data['quote'])
          setStage(2)
        }
      } catch (err) {
        setMessage(err)
      }
      setSubmitting(false)
      setLoading(false)
    },
    [selectedProduct, productDetails, srcAccountDetails, featureList],
  )

  const confirmPayment = useCallback(async () => {
    setLoading(true)
    try {
      // const additionalValues = {}

      // if (
      //   Object.keys(clientAdditionalFields).length > 0 &&
      //   clientAdditionalFields[productDetails?.category]
      // ) {
      //   clientAdditionalFields[productDetails?.category].forEach((item) => {
      //     additionalValues[item.fieldName] = formValues[item.fieldName]
      //   })
      // }

      const response = await PaymentsService.payBill({
        amount: formValues.debitAmount,
        merchant: productDetails?.merchantId || productDetails?.description,
        productId: selectedProduct?.productId || '',
        remarks: formValues.remarks === 'Custom' ? formValues.customRemarks : formValues.remarks,
        serviceId: productDetails.serviceId,
        serviceType: 'test',
        serviceNumber: formValues.serviceNumber,
        srcAccount: srcAccountDetails.accountNo,
        srcAccCcy: srcAccountDetails.currency,
        srcAccBranch: srcAccountDetails.brnCode,
        voucherType: selectedProduct?.name || '',
        quoteId: quoteDetails['quoteId'],
        customerAddress: quoteDetails['customerAddress'] || '',
        senderName: quoteDetails['customerName'] || '',
        otp: otp,
        isScheduled: formValues.isScheduled === 'Yes' ? 'Y' : 'N',
        scheduledDate: formValues.scheduledDate || null,
        cdf: {
          schoolBeneBankType: formValues.schoolBeneBankType,
          schoolBeneBank: formValues.schoolBeneBank,
          className: formValues.className,
          schoolName: formValues.schoolName,
          studentName: formValues.studentName,
          schoolTerm: formValues.schoolTerm,
          feesPurpose: formValues.feesPurpose,
          schoolYear: formValues.schoolYear,
          // ...additionalValues,
        },
      })
      if (response.status === 200) {
        if (formValues.isScheduled === 'No') {
          dispatch(setAccRefresh(true))
        }
        setSuccessResponse(response.data)
        setMessage(response.data['message'] || response.data['responseMessage'])
        setStage(4)
        setLoading(false)
      }
    } catch (err) {
      setLoading(false)
      setOTP('')
    }
    setLoading(false)
  }, [productDetails, selectedProduct, formValues, otp, srcAccountDetails, quoteDetails])

  function renderSwitch() {
    switch (stage) {
      case 1:
        return renderPaymentFormWithoutBills()

      case 2:
        return renderConfirmation()
      case 3:
        return <NeoOTP otp={otp} setOTP={setOTP} onSubmit={confirmPayment} loading={loading} />
      case 4:
        return (
          <NeoSuccess
            onClick1={() =>
              BeneficiaryTransferService.downLoadReport({
                transRefNum: successResponse?.referenceNo,
                receiptNo: successResponse?.receiptNo,
                refId: '',
                module: 'BILLPAYMENT',
              })
            }
            module='DOWNLOAD_RECEIPT'
            message={message}
            linkPath='/payments'
          />
        )
      case 5:
        return renderPaymentFormWithBills()
      default:
        return renderLoading()
    }
  }

  // function createYupSchema(schema, config) {
  //   try {
  //   } catch (err) {}
  //   const { id, validationType, validations = [] } = config
  //   if (!yup[validationType]) {
  //     return schema
  //   }
  //   let validator = yup[validationType]()
  //   validations.forEach((validation) => {
  //     const { params, type } = validation
  //     if (!validator[type]) {
  //       return
  //     }
  //     console.log(type, params)
  //     validator = validator[type](...params)
  //   })
  //   schema[id] = validator
  //   return schema
  // }

  // const getAdditionalFields = useCallback((productDetails) => {
  //   try {
  //     if (
  //       Object.keys(clientAdditionalFields).length > 0 &&
  //       clientAdditionalFields[productDetails?.category]
  //     ) {
  //       const initialValues = {}
  //       const validations = {}
  //       clientAdditionalFields[productDetails?.category].forEach((item) => {
  //         initialValues[item.fieldName] = ''
  //         validations[item.fieldName] = item.mandatory
  //           ? Yup.string().required(`${t(item.fieldLabel)} ${t(PAYMENT_KEYS.IS_REQUIRED)}`)
  //           : Yup.string().optional()
  //       })
  //       setAdditionalFieldValidations(validations)
  //       setAdditionalFieldValues(initialValues)
  //     }
  //   } catch (err) {}
  // }, [])

  const ProductPaymentFormSchema = Yup.object().shape({
    serviceNumber: Yup.string().required(
      `${LABELS[productDetails?.category] || t(PAYMENT_KEYS.SERVICE_NO)} ${t(
        PAYMENT_KEYS.IS_REQUIRED,
      )}`,
    ),
    amount: Yup.string().required(t(VALIDATION_MESSAGES.AMOUNT)),
    remarks: Yup.string().required(t(VALIDATION_MESSAGES.REMARK)),
    product:
      !productDetails.fetchPendingBills && productDetails.products.length > 0
        ? Yup.string().required(t(VALIDATION_MESSAGES.PRODUCT))
        : Yup.string().optional(),
    customRemarks: Yup.string().when('remarks', {
      is: 'Custom',
      then: Yup.string().required(t(VALIDATION_MESSAGES.CUSTOM_REMARKS)),
      otherwise: Yup.string().optional(),
    }),
    isScheduled: Yup.string().required(t(VALIDATION_MESSAGES.SCHEDULE_PAYMENT)),
    scheduledDate: Yup.string().when('isScheduled', {
      is: 'Yes',
      then: Yup.string().required(t(VALIDATION_MESSAGES.SCHEDULE_DATE)),
      otherwise: Yup.string().optional(),
    }),
    billNo:
      billsList.length > 0
        ? Yup.string().required(t(VALIDATION_MESSAGES.BILL_NO))
        : Yup.string().optional(),
    schoolBeneBankType: Yup.string().required(t(VALIDATION_MESSAGES.SCHOOL_BENE_BANK_TYPE)),
    schoolBeneBank: Yup.string().when('schoolBeneBankType', {
      is: 'Other Bank',
      then: Yup.string().required(t(VALIDATION_MESSAGES.SCHOOL_BENE_BANK)),
      otherwise: Yup.string().optional(),
    }),
    className: Yup.string().required(t(VALIDATION_MESSAGES.CLASS_NAME)),
    schoolName: Yup.string().required(t(VALIDATION_MESSAGES.SCHOOL_NAME)),
    studentName: Yup.string().required(t(VALIDATION_MESSAGES.STUDENT_NAME)),
    schoolTerm: Yup.string().required(t(VALIDATION_MESSAGES.SCHOOL_TERM)),
    feesPurpose: Yup.string().required(t(VALIDATION_MESSAGES.FEES_PURPOSE)),
    schoolYear: Yup.string().required(t(VALIDATION_MESSAGES.SCHOOL_YEAR)),
    // ...additionalFieldValidations,
  })

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  // function renderAdditionalFieldsForSpecificClient(
  //   errors,
  //   touched,
  //   handleChange,
  //   values,
  //   setFieldValue,
  // ) {
  //   return (
  //     <>
  //       {Object.keys(clientAdditionalFields).length > 0 &&
  //         clientAdditionalFields[productDetails?.category] && (
  //           <>
  //             {clientAdditionalFields[productDetails?.category].map((field, index) => (
  //               <>
  //               <div className='form-group' key={index}>
  //                 {/* {field.type === 'onlyNumber' && ( */}
  //                   <NeoInput
  //                     tabIndex={index}
  //                     showAsterisk={field.mandatory}
  //                     text={t(field.fieldLabel)}
  //                     onChange={(value) => {
  //                       console.log(value)
  //                       setFieldValue(field?.fieldName, value?.value || value?.target?.value)
  //                     }}
  //                     mode={field.type}
  //                     name={field.fieldName}
  //                     list={field.list}
  //                   />
  //                 {/* )} */}
  //                 <InputError text={errors[field?.fieldName]} touched={touched[field?.fieldName]} />
  //               </div>
  //               </>
  //             ))}
  //           </>
  //         )}
  //     </>
  //   )
  // }

  function renderPaymentFormWithBills() {
    return (
      <div className=''>
        <AccountDisplay currentAccountDetail={srcAccountDetails} />
        <Formik
          enableReinitialize
          initialValues={{
            serviceNumber: selectedProduct ? selectedProduct?.serviceNumber || '' : '',
            amount: selectedProduct ? selectedProduct?.amount || '' : '',
            floatAmount: selectedProduct ? selectedProduct?.amount || undefined : undefined,
            billNo: selectedProduct ? selectedProduct?.billNumber || '' : '',
            remarks: '',
            serviceNumberBen: '',
            showBen: false,
            customRemarks: '',
            isScheduled: 'No',
            scheduledDate: '',
            // ...additionalFieldValues,
          }}
          validationSchema={ProductPaymentFormSchema}
          onSubmit={submitPayment}>
          {({ isSubmitting, errors, touched, handleChange, values, setFieldValue, setTouched }) => (
            <Form>
              <div>
                <div className='row'>
                  <div className='form-group col-8'>
                    {renderBillerBeneDetails(errors, touched, handleChange, values, setFieldValue)}
                  </div>

                  <div style={{ marginTop: 30 }} className='form-group col-4'>
                    {loading1 && <NeoLoader />}
                    {!loading1 && (
                      <NeoButton
                        tabIndex='3'
                        type='button'
                        mode='newDesign'
                        disabled={isSubmitting}
                        text={t(PAYMENT_KEYS.SUBMIT)}
                        onClick={() => fetchPendingBills(values, setTouched)}
                      />
                    )}
                  </div>
                </div>

                {billsList.length > 0 && (
                  <>
                    <div className='form-group'>
                      <NeoInput
                        tabIndex='4'
                        text={t(PAYMENT_KEYS.BILL_NO)}
                        mode='select'
                        name='billNo'
                        showAsterisk={true}
                        onChange={(e) => {
                          handleSelectedBillCallback(e.target.value)
                        }}
                        list={billsList}
                        keyValue='billNumber'
                      />
                      <InputError text={errors.billNo} touched={touched.billNo} />
                    </div>
                    {/* <div className='form-group'>
                      {renderAdditionalFieldsForSpecificClient(
                        errors,
                        touched,
                        handleChange,
                        values,
                        setFieldValue,
                      )}
                    </div> */}
                    <div className='form-group'>
                      <NeoInput
                        tabIndex='5'
                        text={t(DEPOSITS_KEYS.TERM_DEPOSITS_KEYS.AMOUNT)}
                        name='amount'
                        showAsterisk={true}
                        onChange={(values) => {
                          setFieldValue('floatAmount', values.floatValue)
                          setFieldValue('debitAmount', values.value)
                        }}
                        mode='amount'
                        value={values.amount}
                        disabled={selectedProduct.amountType === 'FIXED'}
                      />
                      <InputError text={errors.amount} touched={touched.amount} />
                      {values.floatAmount != undefined && values.floatAmount === 0 && (
                        <InputError
                          text={'Amount should be greater than 0'}
                          touched={touched.amount}
                        />
                      )}
                    </div>
                    {config.SCHEDULED_PAYMENTS && (
                      <>
                        <div className='mt-3 form-group'>
                          <NeoInput
                            tabIndex='7'
                            text={t(DEPOSITS_KEYS.TERM_DEPOSITS_KEYS.SCHEDULE_PAYMENT)}
                            mode='select'
                            showAsterisk={true}
                            name='isScheduled'
                            onChange={(e) => {
                              handleChange(e)
                            }}
                            list={['Yes', 'No']}
                            keyValue={null}
                          />
                          <InputError text={errors.isScheduled} touched={touched.isScheduled} />
                        </div>

                        {values.isScheduled === 'Yes' && (
                          <div className='form-group mt-3'>
                            <NeoInput
                              tabIndex='8'
                              name='scheduledDate'
                              showAsterisk={true}
                              text={t(DEPOSITS_KEYS.TERM_DEPOSITS_KEYS.SCHEDULE_DATE)}
                              icon='calendar_today'
                              mode='single'
                              type='date'
                              onChange={handleChange}
                              min={moment(new Date()).format('YYYY-MM-DD')}
                            />
                            <InputError
                              text={errors.scheduledDate}
                              touched={touched.scheduledDate}
                            />
                          </div>
                        )}
                      </>
                    )}

                    <div className='form-group'>
                      <NeoInput
                        tabIndex='9'
                        text={t(DEPOSITS_KEYS.TERM_DEPOSITS_KEYS.REMARKS)}
                        onChange={handleChange}
                        name='remarks'
                        showAsterisk={true}
                      />
                      <InputError text={errors.remarks} touched={touched.remarks} />
                    </div>

                    <div className='form-group'>
                      {values.remarks === 'Custom' && (
                        <div>
                          <NeoInput
                            tabIndex='10'
                            text={t(DEPOSITS_KEYS.TERM_DEPOSITS_KEYS.CUSTOM_REMARK)}
                            onChange={handleChange}
                            name='customRemarks'
                            showAsterisk={true}
                          />
                          <InputError text={errors.customRemarks} touched={touched.customRemarks} />
                        </div>
                      )}
                    </div>

                    <div className='mt-3 form-group '>
                      {isSubmitting ? (
                        <NeoLoader />
                      ) : (
                        <NeoButton
                          tabIndex='11'
                          type='submit'
                          mode='newDesign'
                          disabled={isSubmitting}
                          text={t(PAYMENT_KEYS.SUBMIT)}
                        />
                      )}
                    </div>
                  </>
                )}
                <div className='back-cancel-btn-container'>
                  <button
                    className='back-cancel-btn btn btn-sm new-design-warning-text-color'
                    tabIndex={'12'}
                    onClick={() => history.goBack()}>
                    {t(SIDENAV_KEYS.TOUCH_ID_KEYS.CANCEL)}
                  </button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    )
  }

  function renderBillerBeneDetails(errors, touched, handleChange, values, setFieldValue) {
    return (
      <>
        {billerBeneList.length > 0 && (
          <div className='form-check biller-bene-checkbox'>
            <Field
              tabIndex='1'
              as='input'
              type='checkbox'
              className='form-check-input'
              id='check1'
              name='showBen'
              checked={values.showBen}
              onChange={() => {
                setFieldValue('showBen', !values.showBen)
                setFieldValue('serviceNumber', '')
                // setBillsList([])
                // setFieldValue('billNo','')
              }}
            />
            <label htmlFor='check1' className='form-check-label'>
              {t(SIDENAV_KEYS.BENEFICIARIES)}
            </label>
          </div>
        )}
        {!values.showBen && (
          <>
            <NeoInput
              tabIndex='2'
              text={LABELS[productDetails?.category] || t(PAYMENT_KEYS.SERVICE_NO)}
              onChange={handleChange}
              name='serviceNumber'
              showAsterisk={true}
              value={values.serviceNumber}
            />
            <InputError text={errors.serviceNumber} touched={touched.serviceNumber} />
          </>
        )}

        {values.showBen && (
          <>
            {/* <NeoInput
              tabIndex='2'
              text={LABELS[productDetails?.category] || t(PAYMENT_KEYS.SERVICE_NO)}
              showAsterisk={true}
              mode='select'
              name='serviceNumber'
              onChange={handleChange}
              list={billerBeneList}
              keyValue='serviceNumber'
              value={values.serviceNumber}
            /> */}
            <label className='control-label'>
              {LABELS[productDetails?.category] || t(PAYMENT_KEYS.SERVICE_NO)}
              {' *'}
            </label>
            <Field
              tabIndex='2'
              as='select'
              name='serviceNumber'
              className='form-control'
              onChange={handleChange}>
              <option value='' />
              {billerBeneList.map((option, index) => (
                <option value={option.serviceNumber} key={index}>
                  {option.shortName}
                </option>
              ))}
            </Field>
            <InputError text={errors.serviceNumber} touched={touched.serviceNumber} />
          </>
        )}
      </>
    )
  }

  function renderPaymentFormWithoutBills() {
    return (
      <div className=''>
        <AccountDisplay currentAccountDetail={srcAccountDetails} />
        <Formik
          enableReinitialize
          initialValues={{
            serviceNumber: '',
            amount: selectedProduct ? selectedProduct?.productAmount || '' : '',
            floatAmount: selectedProduct ? selectedProduct?.productAmount || undefined : undefined,
            product: selectedProduct ? selectedProduct?.description || '' : '',
            remarks: '',
            serviceNumberBen: '',
            showBen: false,
            customRemarks: '',
            isScheduled: 'No',
            scheduledDate: '',
            mobileNo: '',
            schoolBeneBankType: '',
            schoolBeneBank: '',
            className: '',
            schoolName: '',
            studentName: '',
            schoolTerm: '',
            feesPurpose: '',
            schoolYear: '',
            // ...additionalFieldValues,
          }}
          validationSchema={ProductPaymentFormSchema}
          onSubmit={submitPayment}>
          {({ isSubmitting, errors, touched, handleChange, values, setFieldValue }) => (
            <Form>
              <div>
                {productDetails.products.length > 0 && (
                  <div className='row'>
                    <div className='form-group col-12'>
                      <NeoInput
                        tabIndex='1'
                        text={t(PAYMENT_KEYS.PRODUCT)}
                        showAsterisk={true}
                        mode='select'
                        name='product'
                        onChange={(e) => {
                          setSelectedProductCallback(e.target.value)
                          handleChange(e)
                          setFieldValue('amount', '')
                        }}
                        list={productDetails.products}
                        keyValue='description'
                      />
                      <InputError text={errors.product} touched={touched.product} />
                    </div>
                  </div>
                )}

                <div className='row'>
                  <div className='form-group col-12'>
                    {renderBillerBeneDetails(errors, touched, handleChange, values, setFieldValue)}
                  </div>
                  <div className='form-group col-12'>
                    <NeoInput
                      tabIndex='5'
                      text={t(PAYMENT_KEYS.SCHOOL_BENE_BANK_TYPE)}
                      mode='select'
                      name='schoolBeneBankType'
                      onChange={(e) => {
                        handleChange(e)
                      }}
                      list={['NBS Bank', 'Other Bank']}
                      showAsterisk={true}
                      keyValue={null}
                    />
                    <InputError
                      text={errors.schoolBeneBankType}
                      touched={touched.schoolBeneBankType}
                    />
                  </div>
                  {values.schoolBeneBankType === 'Other Bank' && (
                    <div className='form-group col-12'>
                      <NeoInput
                        showAsterisk={true}
                        text={t(PAYMENT_KEYS.SCHOOL_BENE_BANK)}
                        name='schoolBeneBank'
                        mode='select'
                        onChange={(text) => handleChange(text)}
                        list={banks}
                      />
                      <InputError text={errors.schoolBeneBank} touched={touched.schoolBeneBank} />
                    </div>
                  )}
                  <div className='form-group col-12'>
                    <NeoInput
                      tabIndex='2'
                      text={t(PAYMENT_KEYS.CLASS_NAME)}
                      onChange={handleChange}
                      name='className'
                      showAsterisk={true}
                      value={values.className}
                    />
                    <InputError text={errors.className} touched={touched.className} />
                  </div>
                  <div className='form-group col-12'>
                    <NeoInput
                      tabIndex='2'
                      text={t(PAYMENT_KEYS.SCHOOL_NAME)}
                      onChange={handleChange}
                      name='schoolName'
                      showAsterisk={true}
                      value={values.schoolName}
                    />
                    <InputError text={errors.schoolName} touched={touched.schoolName} />
                  </div>
                  <div className='form-group col-12'>
                    <NeoInput
                      tabIndex='2'
                      text={t(PAYMENT_KEYS.STUDENT_NAME)}
                      onChange={handleChange}
                      name='studentName'
                      showAsterisk={true}
                      value={values.studentName}
                    />
                    <InputError text={errors.studentName} touched={touched.studentName} />
                  </div>
                  <div className='form-group col-12'>
                    <NeoInput
                      tabIndex='5'
                      text={t(PAYMENT_KEYS.SCHOOL_TERM)}
                      mode='select'
                      name='schoolTerm'
                      onChange={(e) => {
                        handleChange(e)
                      }}
                      list={['1', '2', '3']}
                      showAsterisk={true}
                      keyValue={null}
                    />
                    <InputError text={errors.schoolTerm} touched={touched.schoolTerm} />
                  </div>
                  <div className='form-group col-12'>
                    <NeoInput
                      tabIndex='5'
                      text={t(PAYMENT_KEYS.FEES_PURPOSE)}
                      mode='select'
                      name='feesPurpose'
                      onChange={(e) => {
                        handleChange(e)
                      }}
                      list={['Tuition', 'SDC Levy', 'Special Levy']}
                      showAsterisk={true}
                      keyValue={null}
                    />
                    <InputError text={errors.feesPurpose} touched={touched.feesPurpose} />
                  </div>
                  <div className='form-group col-12'>
                    <NeoInput
                      tabIndex='5'
                      text={t(PAYMENT_KEYS.SCHOOL_YEAR)}
                      mode='select'
                      name='schoolYear'
                      onChange={(e) => {
                        handleChange(e)
                      }}
                      list={years}
                      value={getYear(startDate)}
                      showAsterisk={true}
                      keyValue={null}
                    />
                    <InputError text={errors.schoolYear} touched={touched.schoolYear} />
                  </div>
                  {/* <div className='form-group col-12'>
                    {renderAdditionalFieldsForSpecificClient(
                      errors,
                      touched,
                      handleChange,
                      values,
                      setFieldValue,
                    )}
                  </div> */}

                  <div className='form-group col-12'>
                    <NeoInput
                      tabIndex='4'
                      text={t(DEPOSITS_KEYS.TERM_DEPOSITS_KEYS.AMOUNT)}
                      name='amount'
                      onChange={(values) => {
                        setFieldValue('floatAmount', values.floatValue)
                        setFieldValue('debitAmount', values.value)
                      }}
                      mode='amount'
                      showAsterisk={true}
                      value={values.amount}
                      disabled={selectedProduct.amountType === 'FIXED'}
                    />
                    <InputError text={errors.amount} touched={touched.amount} />
                    {values.floatAmount != undefined && values.floatAmount === 0 && (
                      <InputError
                        text={'Amount should be greater than 0'}
                        touched={touched.amount}
                      />
                    )}
                  </div>
                </div>

                {config.SCHEDULED_PAYMENTS && (
                  <>
                    <div className='mt-3 form-group'>
                      <NeoInput
                        tabIndex='5'
                        text={t(DEPOSITS_KEYS.TERM_DEPOSITS_KEYS.SCHEDULE_PAYMENT)}
                        mode='select'
                        name='isScheduled'
                        onChange={(e) => {
                          handleChange(e)
                        }}
                        list={['Yes', 'No']}
                        showAsterisk={true}
                        keyValue={null}
                      />
                      <InputError text={errors.isScheduled} touched={touched.isScheduled} />
                    </div>

                    {values.isScheduled === 'Yes' && (
                      <div className='form-group mt-3'>
                        <NeoInput
                          tabIndex='6'
                          name='scheduledDate'
                          text={t(DEPOSITS_KEYS.TERM_DEPOSITS_KEYS.SCHEDULE_DATE)}
                          icon='calendar_today'
                          mode='single'
                          type='date'
                          onChange={handleChange}
                          showAsterisk={true}
                          min={moment(new Date()).format('YYYY-MM-DD')}
                        />
                        <InputError text={errors.scheduledDate} touched={touched.scheduledDate} />
                      </div>
                    )}
                  </>
                )}
                <div className='row'>
                  <div className='form-group col-12'>
                    <NeoInput
                      tabIndex='7'
                      text={t(DEPOSITS_KEYS.TERM_DEPOSITS_KEYS.REMARKS)}
                      onChange={handleChange}
                      name='remarks'
                      showAsterisk={true}
                    />
                    <InputError text={errors.remarks} touched={touched.remarks} />
                  </div>
                </div>
                <div className='row'>
                  <div className='form-group col-12'>
                    {values.remarks === 'Custom' && (
                      <>
                        <NeoInput
                          tabIndex='8'
                          text={t(DEPOSITS_KEYS.TERM_DEPOSITS_KEYS.CUSTOM_REMARK)}
                          onChange={handleChange}
                          showAsterisk={true}
                          name='customRemarks'
                        />
                        <InputError text={errors.customRemarks} touched={touched.customRemarks} />
                      </>
                    )}
                  </div>
                </div>
                <div className='row'>
                  <div className='form-group col-12'>
                    {isSubmitting ? (
                      <NeoLoader />
                    ) : (
                      <NeoButton
                        tabIndex='9'
                        type='submit'
                        mode='newDesign'
                        disabled={isSubmitting}
                        text={t(PAYMENT_KEYS.SUBMIT)}
                      />
                    )}
                  </div>
                </div>
                <div className='back-cancel-btn-container'>
                  <button
                    className='back-cancel-btn btn btn-sm new-design-warning-text-color'
                    tabIndex={'10'}
                    onClick={() => history.goBack()}>
                    {t(SIDENAV_KEYS.TOUCH_ID_KEYS.CANCEL)}
                  </button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    )
  }

  function renderConfirmation() {
    return (
      <div>
        <div className='d-flex flex-column confirmation'>
          <AccountDisplay currentAccountDetail={srcAccountDetails} />

          {/* <div>
            <h6 className='label'>{t(PAYMENT_KEYS.BILLER_NAME)}</h6>
            <h6 className='value'>{selectedBiller?.description}</h6>
          </div> */}

          <div>
            <h6 className='label'>
              {LABELS[productDetails?.category] || t(PAYMENT_KEYS.SERVICE_NO)}
            </h6>
            {formValues.showBen ? (
              <h6 className='value'>
                {
                  billerBeneList.filter((e) => e.serviceNumber === formValues?.serviceNumber)[0]
                    ?.shortName
                }{' '}
                {'(' + formValues?.serviceNumber + ')'}
              </h6>
            ) : (
              <h6 className='value'>{formValues?.serviceNumber}</h6>
            )}
          </div>

          {productDetails?.fetchPendingBills && (
            <>
              <div>
                <h6 className='label'>{t(PAYMENT_KEYS.BILL_NO)}</h6>
                <h6 className='value'>{selectedProduct?.billNumber}</h6>
              </div>
              <div>
                <h6 className='label'>{t(PAYMENT_KEYS.BILL_DATE)}</h6>
                <h6 className='value'>{moment(selectedProduct?.billDate).format('DD-MM-YYYY')}</h6>
              </div>
              <div>
                <h6 className='label'>{t(PAYMENT_KEYS.BILL_DUE_DATE)}</h6>
                <h6 className='value'>
                  {moment(selectedProduct?.billDueDate).format('DD-MM-YYYY')}
                </h6>
              </div>
            </>
          )}

          {productDetails.category === 'SUBSCRIPTION' && quoteDetails['customerName'] && (
            <div>
              <h6 className='label'>{t(PAYMENT_KEYS.CUSTOMER_NAME)}</h6>
              <h6 className='value'>{quoteDetails['customerName'] || '-'}</h6>
            </div>
          )}

          {/* <div>
            <h6 className='label'>{t(PAYMENT_KEYS.QUOTE_ID)}</h6>
            <h6 className='value'>{quoteDetails['quoteId']}</h6>
          </div> */}
          {/* <div>
            <h6 className='label'>{'Customer Name'}</h6>
            <h6 className='value'>{quoteDetails['customerName'] || '-'}</h6>
          </div>

          <div>
            <h6 className='label'>{'Customer Address'}</h6>
            <h6 className='value'>{quoteDetails['customerAddress'] || '-'}</h6>
          </div> */}

          {/* <div>
            <h6 className='label'>{'Amount Due'}</h6>
            <h6 className='value'>{quoteDetails['amountDue'] || '0.00'}</h6>
          </div> */}

          {/* {Object.keys(clientAdditionalFields).length > 0 &&
            clientAdditionalFields[productDetails?.category] && (
              <>
                {clientAdditionalFields[productDetails?.category].map((field, index) => (
                  <>
                  {formValues[field?.fieldName] !== "" &&
                  <div key={index}>
                    <h6 className='label'>{t(field?.fieldLabel)}</h6>
                    <h6 className='value'>{formValues[field?.fieldName]}</h6>
                  </div>
                  }
                  </>
                ))}
              </>
            )} */}

          <div>
            <h6 className='label'>{t(PAYMENT_KEYS.SCHOOL_BENE_BANK_TYPE)}</h6>
            <h6 className='value'>{formValues?.schoolBeneBankType}</h6>
          </div>

          {formValues?.schoolBeneBankType === 'Other Bank' && (
            <div>
              <h6 className='label'>{t(PAYMENT_KEYS.SCHOOL_BENE_BANK)}</h6>
              <h6 className='value'>{formValues?.schoolBeneBank}</h6>
            </div>
          )}
          <div>
            <h6 className='label'>{t(PAYMENT_KEYS.CLASS_NAME)}</h6>
            <h6 className='value'>{formValues?.className}</h6>
          </div>

          <div>
            <h6 className='label'>{t(PAYMENT_KEYS.SCHOOL_NAME)}</h6>
            <h6 className='value'>{formValues?.schoolName}</h6>
          </div>

          <div>
            <h6 className='label'>{t(PAYMENT_KEYS.STUDENT_NAME)}</h6>
            <h6 className='value'>{formValues?.studentName}</h6>
          </div>

          <div>
            <h6 className='label'>{t(PAYMENT_KEYS.SCHOOL_TERM)}</h6>
            <h6 className='value'>{formValues?.schoolTerm}</h6>
          </div>

          <div>
            <h6 className='label'>{t(PAYMENT_KEYS.FEES_PURPOSE)}</h6>
            <h6 className='value'>{formValues?.feesPurpose}</h6>
          </div>

          <div>
            <h6 className='label'>{t(PAYMENT_KEYS.SCHOOL_YEAR)}</h6>
            <h6 className='value'>{formValues?.schoolYear}</h6>
          </div>

          <div>
            <h6 className='label'>{t(DEPOSITS_KEYS.TERM_DEPOSITS_KEYS.AMOUNT_DETAILS)}</h6>
            <h6 className='value'>
              <NumberFormat
                value={formValues?.debitAmount}
                displayType={'text'}
                thousandSeparator={true}
                prefix={''}
                fixedDecimalScale={true}
                decimalScale={2}
                allowEmptyFormatting
              />
            </h6>
          </div>

          {formValues?.isScheduled === 'Yes' && (
            <div>
              <h6 className='label'>{t(DEPOSITS_KEYS.TERM_DEPOSITS_KEYS.SCHEDULE_DATE1)}</h6>
              <h6 className='value'>{formValues?.scheduledDate}</h6>
            </div>
          )}

          <div>
            <h6 className='label'>{t(PAYMENT_KEYS.REMARK)}</h6>
            <h6 className='value'>
              {formValues?.remarks === 'Custom' ? formValues?.customRemarks : formValues?.remarks}
            </h6>
          </div>

          <div>
            <TermsAndConditions module='BILLPAYMENT' />
          </div>
          <div className='mt-3 form-group col-12'>
            {loading ? (
              <NeoLoader />
            ) : (
              <NeoButton
                type='button'
                text={t(DEPOSITS_KEYS.TERM_DEPOSITS_KEYS.CONFIRM_BUTTON)}
                mode='newDesign'
                onClick={async () => {
                  otpEnabled ? setStage(3) : await confirmPayment()
                }}
              />
            )}
          </div>
          <div className='back-cancel-style' onClick={() => setStage(1)}>
            {t(SIDENAV_KEYS.TOUCH_ID_KEYS.BACK)}
          </div>
        </div>
      </div>
    )
  }

  return (
    <LayoutWithAccountCard
      pageTitle={`${selectedBiller?.category} - ${selectedBiller?.description}`}
      breadCumKey='BILLER_SERVICE_FORM'>
      <div className='new-design-form-style'>
        <div className='heading-style'>
          {selectedBiller?.category}- {selectedBiller?.description}
        </div>
        {renderSwitch()}
      </div>
    </LayoutWithAccountCard>
  )
}
